import { Eye, MapPin, MessageCircle, Users } from 'lucide-react';
import Hotspot from './Hotspot';

/** Fictional preview only. Identity: Sophie Lin (see @/lib/demo-content). No real user data. */
export default function SocialStorytellingPreview() {
  return (
    <div className="relative min-w-0">
      <div className="overflow-hidden rounded-[14px] border border-slate-200 bg-white">
        <div className="flex items-center gap-3 px-4 pt-4">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#12372c] text-xs font-bold text-[#98f2d3]">
            SL
          </span>
          <div className="min-w-0">
            <p className="truncate text-xs font-bold text-slate-900">Sophie Lin</p>
            <p className="truncate text-[11px] text-slate-500">@sophie.lin</p>
          </div>
          <span className="ml-auto shrink-0 rounded-full bg-[#eaf3de] px-2.5 py-1 text-[10px] font-bold text-[#3b6d11]">
            Achievement
          </span>
        </div>

        <div className="px-4 pt-3">
          <p className="text-sm font-bold leading-snug text-slate-900">First winter in Canada</p>
          <p className="mt-1.5 text-xs leading-6 text-slate-600">
            Documenting arrival, language milestones, and the first community winter festival --
            from the perspective of a family that had never seen snow.
          </p>
        </div>

        <div className="mt-3 flex items-center justify-between border-t border-slate-100 px-4 py-2.5 text-[11px] text-slate-500">
          <span className="inline-flex items-center gap-1.5">
            <Eye size={12} aria-hidden="true" />
            19 witnessed
          </span>
          <span className="inline-flex items-center gap-1.5">
            <MessageCircle size={12} aria-hidden="true" />8 comments
          </span>
          <Hotspot
            label="Open Story"
            note="A public story can carry dates, media and connected people -- more than a caption ever could."
          />
        </div>
      </div>

      <div className="relative mt-3 flex items-center gap-3 rounded-[9px] border border-[#5fa8d3]/30 bg-[#eef6fb] p-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#162e40] text-[#a9d9f2]">
          <MapPin size={14} aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-xs font-bold text-slate-900">Connected to the Journey Map</p>
          <p className="truncate text-[11px] text-slate-500">
            Greater Vancouver &middot; shared with 2 circles
          </p>
        </div>
        <Users size={15} className="ml-auto shrink-0 text-[#5fa8d3]" aria-hidden="true" />
        <Hotspot
          label="View Journey"
          note="Public stories can stay linked to the same Journey Map used across the rest of the record."
          className="absolute -bottom-3 right-3"
        />
      </div>
    </div>
  );
}
